/* =====================================================
   Quick View Modal interactions
   - <quick-view-dropdown>: custom select with image thumbnails per option.
   - The product-variants component (theme) handles VARIANT_CHANGE and
     refreshes everything tagged with [data-update-block] automatically.
   ===================================================== */

(function () {
  if (customElements.get('quick-view-dropdown')) return;

  class QuickViewDropdown extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.quick-view-dropdown__trigger');
      this.list = this.querySelector('.quick-view-dropdown__list');
      this.inputs = this.querySelectorAll('input[type="radio"]');

      if (!this.trigger || !this.list) return;

      this._onTriggerClick = this._onTriggerClick.bind(this);
      this._onDocumentClick = this._onDocumentClick.bind(this);
      this._onKeyDown = this._onKeyDown.bind(this);
      this._onInputChange = this._onInputChange.bind(this);

      this.trigger.addEventListener('click', this._onTriggerClick);
      document.addEventListener('click', this._onDocumentClick);
      document.addEventListener('keydown', this._onKeyDown);
      this.inputs.forEach((input) => {
        input.addEventListener('change', this._onInputChange);
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocumentClick);
      document.removeEventListener('keydown', this._onKeyDown);
    }

    _onTriggerClick(e) {
      e.preventDefault();
      this.toggle();
    }

    _onDocumentClick(e) {
      if (!this.contains(e.target)) this.close();
    }

    _onKeyDown(e) {
      if (e.key === 'Escape') this.close();
    }

    _onInputChange() {
      this._syncCheckmark();
      this.close();
    }

    toggle() {
      if (this.list.hasAttribute('hidden')) this.open();
      else this.close();
    }

    open() {
      this.list.removeAttribute('hidden');
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.list.setAttribute('hidden', '');
      this.trigger.setAttribute('aria-expanded', 'false');
    }

    /**
     * Updates `.is-selected` and aria-selected on the option list (visual checkmark).
     * The trigger thumb/label are updated by the theme via data-update-block.
     */
    _syncCheckmark() {
      const checked = this.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      const option = checked.closest('.quick-view-dropdown__option');
      if (!option) return;

      this.querySelectorAll('.quick-view-dropdown__option.is-selected').forEach((el) => {
        el.classList.remove('is-selected');
        el.setAttribute('aria-selected', 'false');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-selected', 'true');
    }
  }

  customElements.define('quick-view-dropdown', QuickViewDropdown);
})();
